export default [
  {
    name: 'ensuiteRoom',
    labelKey: 'search.filter.ensuite_room'
  },
  {
    name: 'heating',
    labelKey: 'search.filter.heating'
  },
  {
    name: 'balcony',
    labelKey: 'search.filter.balcony'
  },
  {
    name: 'air_conditioning',
    labelKey: 'search.filter.air_conditioning'
  },
  {
    name: 'parking',
    labelKey: 'search.filter.parking'
  },
  {
    name: 'withDesk',
    labelKey: 'search.filter.with_desk'
  },
  {
    name: 'pool',
    labelKey: 'search.filter.pool'
  },
  {
    name: 'elevator',
    labelKey: 'search.filter.elevator'
  },
  {
    name: 'exterior',
    labelKey: 'search.filter.exterior'
  },
  {
    name: 'dryer',
    labelKey: 'search.filter.dryer'
  },
  {
    name: 'oven',
    labelKey: 'search.filter.oven'
  },
  {
    name: 'dishwasher',
    labelKey: 'search.filter.dishwasher'
  },
  {
    name: 'washing_machine',
    labelKey: 'search.filter.washingMachine'
  }
];
